import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AnimatedIconTransitionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getMirrorStyle
} from "../../../../helpers/direction";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isMirrored,
    direction,
    size
}: AnimatedIconTransitionDynamicStyleType) => {
    const styles = {
        container: {
            ...getMirrorStyle({
                isMirrored,
                direction
            }),
            height: size,
            width: size
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
